// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M2.25.5h6.687l.22.22 1.125 1.125.22.22V4.25H9V2.687L8.313 2H3v2.25H1.5V.5h.75zm-.75 9H0V5h12v4.5h-1.5v3h-9v-3zm1.5 0V11h6V8.75H3v.75zm6.563-3.188v1.125h1.124V6.313H9.563z" />
        </svg>
    );
};

export default React.memo(Print);
